const Ordering = {
  id: "menu",
  title: "Ordering",
  subtitle: "Ordering Design and Setup",
  type: "group",
  icon: "heroicons-outline:fire",
  children: [
    {
      id: "apps.notifications",
      title: "Notifications",
      type: "item",
      icon: "heroicons-outline:bell",
      url: "/apps/notifications",
    },
    {
      id: "apps.scrumboard",
      title: "Admin manager",
      subtitle: "3 currents tasks",
      type: "item",
      icon: "heroicons-outline:view-columns",
      url: "/apps/scrumboard",
      // translate: "SCRUMBOARD",
    },
    {
      id: "apps.tasks",
      title: "Current Tasks",
      subtitle: "12 remaining tasks",
      type: "item",
      icon: "heroicons-outline:check-circle",
      url: "/apps/tasks",
      // translate: "TASKS",
    },
    {
      id: "apps.ecommerce",
      title: "Menu Design",
      type: "collapse",
      icon: "heroicons-outline:swatch",
      // translate: "ECOMMERCE",
      children: [
        {
          id: "e-commerce-category",
          title: "Categories",
          type: "item",
          url: "/apps/e-commerce/products",
          end: true,
        },
        {
          id: "e-commerce-category-ki",
          title: "Categories Thong Ha",
          type: "item",
          url: "/ordering/menu-category",
          end: true,
        },
        {
          id: "e-commerce-products",
          title: "Menu",
          type: "item",
          url: "/apps/e-commerce/products",
          end: true,
        },
        {
          id: "e-commerce-product-detail",
          title: "Menu Detail",
          type: "item",
          url: "/apps/e-commerce/products/1/a-walk-amongst-friends-canvas-print",
        },
        {
          id: "e-commerce-new-product",
          title: "New Menu Item",
          type: "item",
          url: "/apps/e-commerce/products/new",
        },
      ],
    },
    {
      id: "apps.ecommerce2",
      title: "Orders",
      type: "collapse",
      icon: "heroicons-outline:truck",
      // translate: "ECOMMERCE",
      children: [
        {
          id: "e-commerce-orders",
          title: "Orders",
          type: "item",
          url: "/apps/e-commerce/orders",
          end: true,
        },
        {
          id: "e-commerce-order-detail",
          title: "Order Detail",
          type: "item",
          url: "/apps/e-commerce/orders/1",
        },
      ],
    },
    // {
    //   id: "apps.academy",
    //   title: "Academy",
    //   type: "item",
    //   icon: "heroicons-outline:academic-cap",
    //   url: "/apps/academy",
    //   translate: "ACADEMY",
    // },
    {
      id: "apps.calendar",
      title: "Calendar",
      subtitle: "3 upcoming events",
      type: "item",
      icon: "heroicons-outline:calendar",
      url: "/apps/calendar",
      translate: "CALENDAR",
    },
    {
      id: "apps.messenger",
      title: "Messenger",
      type: "item",
      icon: "heroicons-outline:chat-bubble-bottom-center",
      url: "/apps/messenger",
      translate: "MESSENGER",
    },
    {
      id: "apps.contacts",
      title: "Loyalty customers",
      type: "item",
      icon: "heroicons-outline:user-group",
      url: "/apps/contacts",
      // translate: "CONTACTS",
    },
    {
      id: "apps.file-manager",
      title: "Photos",
      type: "item",
      icon: "heroicons-outline:cloud",
      url: "/apps/file-manager",
      end: true,
      // translate: "FILE_MANAGER",
    },
    {
      id: "apps.notes",
      title: "Notes",
      type: "item",
      icon: "heroicons-outline:pencil-square",
      url: "/apps/notes",
      // translate: "NOTES",
    },

    // {
    //   id: "apps.mailbox",
    //   title: "Mailbox",
    //   type: "item",
    //   icon: "heroicons-outline:envelope",
    //   url: "/apps/mailbox",
    //   translate: "MAIL",
    //   badge: {
    //     title: "27",
    //     classes: "px-8 bg-pink-600 text-white rounded-full",
    //   },
    // },

    // {
    //   id: "apps.profile",
    //   title: "Profile",
    //   type: "item",
    //   icon: "heroicons-outline:user-circle",
    //   url: "/apps/profile",
    // },

    // {
    //   ...SettingsAppNavigation,
    //   type: "item",
    //   badge: {
    //     title: "NEW",
    //   },
    // },
    {
      id: "apps.help-center",
      title: "Help Center",
      type: "collapse",
      icon: "heroicons-outline:information-circle",
      url: "/apps/help-center",
      children: [
        {
          id: "apps.help-center.home",
          title: "Home",
          type: "item",
          url: "/apps/help-center",
          end: true,
        },
        {
          id: "apps.help-center.faqs",
          title: "FAQs",
          type: "item",
          url: "/apps/help-center/faqs",
        },
        {
          id: "apps.help-center.guides",
          title: "Guides",
          type: "item",
          url: "/apps/help-center/guides",
        },
        {
          id: "apps.help-center.support",
          title: "Support",
          type: "item",
          url: "/apps/help-center/support",
        },
      ],
    },
  ],
};
export default Ordering;
